export default "__VITE_ASSET__d6b4bc28__"